import React, { useState } from 'react';

const UnitCard = ({ unit, onInquire, onImageClick, onStatusChange, isAdmin, onVideoClick }) => {

  // Promotion options
  const promotions = [
    { key: '20', label: '20% Down Payment', discount: 5 },
    { key: '50', label: '50% Down Payment', discount: 10 },
    { key: '100', label: '100% (Full) Payment', discount: 15 },
  ];
  const [selectedPromo, setSelectedPromo] = useState('20');

  return (
    <div className={`unit-card ${unit.status}`}>
      <div className={unit.status}>
        <span className="status-dot"></span>
        <small style={{ textTransform: 'uppercase', letterSpacing: '1px' }}>{unit.status}</small>
      </div>
      <h3 style={{ margin: '10px 0' }}>Unit {unit.id}</h3>
      <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>{unit.type}<br />{unit.sqft} m. sq.</p>

      <div>
        <ul style={{ listStyle: 'none', padding: 0, marginBottom: 10 }}>
          {promotions.map(promo => (
            <li key={promo.key} style={{
              background: selectedPromo === promo.key ? '#e0f7fa' : '#f9f9f9',
              border: selectedPromo === promo.key ? '2px solid #0097a7' : '1px solid #ccc',
              borderRadius: 6,
              marginBottom: 6,
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontWeight: selectedPromo === promo.key ? 'bold' : 'normal',
            }}
            onClick={() => setSelectedPromo(promo.key)}
            >
              <span>{promo.label} — <span style={{color:'#009688'}}>{promo.discount}% Discount</span></span>
            </li>
          ))}
        </ul>
        {unit.status === 'available' && (
          <div style={{marginBottom: 10, color: '#009688', fontWeight: 500, fontSize: '0.98rem'}}>
            Inquire now for pricing details.
          </div>
        )}
      </div>

      {unit.status === 'available' ? (
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button className="btn-action" onClick={() => onImageClick(unit.image)}>Floor Plan</button>
          {onVideoClick && (
            <button className="btn-action" onClick={() => onVideoClick(unit)}>
              Interior View
            </button>
          )}
          <button className="btn-action" onClick={() => onInquire(unit)}>Inquire Now</button>
          {isAdmin && <button className="btn-action" onClick={() => onStatusChange(unit.id)}>Mark as Unavailable</button>}
        </div>
      ) : unit.status === 'reserved' ? (
        <button className="btn-disabled">Reserved</button>
      ) : (
        isAdmin 
          ? <button className="btn-action" onClick={() => onStatusChange(unit.id)}>Mark as Available</button>
          : <button className="btn-disabled">Sold</button>
      )}
    </div>
  );
};

const UnitGrid = ({ units, onInquire, onImageClick, onStatusChange, isAdmin, onVideoClick }) => (
  <div className="unit-grid">
    {units.map(unit => (
      <UnitCard
        key={unit.id}
        unit={unit}
        onInquire={onInquire}
        onImageClick={onImageClick}
        onStatusChange={onStatusChange}
        isAdmin={isAdmin}
        onVideoClick={onVideoClick}
      />
    ))}
  </div>
);

export default UnitGrid;
